/**
 * Generated by orval v6.28.2 🍺
 * Do not edit manually.
 * Maybern
 * Maybern API
 * OpenAPI spec version: 0.0.0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query'
import type {
  FeeBasisCategoryRelationAPIData
} from '../../model/feeBasisCategoryRelationAPIData'
import type {
  FeeBasisCategoryRelationCreateAPIDataRequest
} from '../../model/feeBasisCategoryRelationCreateAPIDataRequest'
import type {
  FeeBasisCreateDataRequest
} from '../../model/feeBasisCreateDataRequest'
import type {
  FeeBasisData
} from '../../model/feeBasisData'
import type {
  FeeBasisDataList
} from '../../model/feeBasisDataList'
import type {
  TransactionCalculationFeeBasisViewData
} from '../../model/transactionCalculationFeeBasisViewData'
import type {
  TransactionCalculationPayloadCreateDataRequest
} from '../../model/transactionCalculationPayloadCreateDataRequest'
import { axiosRequest } from '../../../shared/api/Api';


      
type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];



      import { appQueryClient } from "app/AppQueryClient";
      import { LoaderFunction, Params } from "@remix-run/router";
      import { isLoggedIn } from "axios-jwt";

      const authedLoader = (loader: LoaderFunction): LoaderFunction =>
        async (args) => {
          const result = await isLoggedIn();
          if (result) {
            return loader(args);
          }
          return null;
        };
    /**
 * Lists all Fee Basis
 */
export const feeBasisRetrieve = (
    fundFamilyId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<FeeBasisDataList>(
      {url: `/fund-family/${fundFamilyId}/fee-basis/`, method: 'GET', signal
    },
      options);
    }
  

export const getFeeBasisRetrieveQueryKey = (fundFamilyId: string,) => {
    return [`/fund-family/${fundFamilyId}/fee-basis/`] as const;
    }

    
export const getFeeBasisRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof feeBasisRetrieve>>, TError = unknown>(fundFamilyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof feeBasisRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFeeBasisRetrieveQueryKey(fundFamilyId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof feeBasisRetrieve>>> = ({ signal }) => feeBasisRetrieve(fundFamilyId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof feeBasisRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type FeeBasisRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof feeBasisRetrieve>>>
export type FeeBasisRetrieveQueryError = unknown

export const useFeeBasisRetrieve = <TData = Awaited<ReturnType<typeof feeBasisRetrieve>>, TError = unknown>(
 fundFamilyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof feeBasisRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFeeBasisRetrieveQueryOptions(fundFamilyId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getFeeBasisRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof feeBasisRetrieve>>, TError = unknown>(fundFamilyId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof feeBasisRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFeeBasisRetrieveQueryKey(fundFamilyId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof feeBasisRetrieve>>> = ({ signal }) => feeBasisRetrieve(fundFamilyId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof feeBasisRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type FeeBasisRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof feeBasisRetrieve>>>
export type FeeBasisRetrieveSuspenseQueryError = unknown

export const useFeeBasisRetrieveSuspense = <TData = Awaited<ReturnType<typeof feeBasisRetrieve>>, TError = unknown>(
 fundFamilyId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof feeBasisRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFeeBasisRetrieveSuspenseQueryOptions(fundFamilyId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getFeeBasisRetrieveLoader = (paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (fundFamilyId) {
            return appQueryClient.prefetchQuery({
              queryKey: getFeeBasisRetrieveQueryKey(fundFamilyId),
              queryFn: () => feeBasisRetrieve(fundFamilyId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Creates a Fee Basis
 */
export const feeBasisCreate = (
    fundFamilyId: string,
    feeBasisCreateDataRequest: FeeBasisCreateDataRequest,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<FeeBasisData>(
      {url: `/fund-family/${fundFamilyId}/fee-basis/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: feeBasisCreateDataRequest
    },
      options);
    }
  


export const getFeeBasisCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof feeBasisCreate>>, TError,{fundFamilyId: string;data: FeeBasisCreateDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof feeBasisCreate>>, TError,{fundFamilyId: string;data: FeeBasisCreateDataRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof feeBasisCreate>>, {fundFamilyId: string;data: FeeBasisCreateDataRequest}> = (props) => {
          const {fundFamilyId,data} = props ?? {};

          return  feeBasisCreate(fundFamilyId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type FeeBasisCreateMutationResult = NonNullable<Awaited<ReturnType<typeof feeBasisCreate>>>
    export type FeeBasisCreateMutationBody = FeeBasisCreateDataRequest
    export type FeeBasisCreateMutationError = unknown

    export const useFeeBasisCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof feeBasisCreate>>, TError,{fundFamilyId: string;data: FeeBasisCreateDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getFeeBasisCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Creates Fee Basis Category Relations
 */
export const feeBasisCategoryRelationCreate = (
    fundFamilyId: string,
    feeBasisId: string,
    feeBasisCategoryId: string,
    feeBasisCategoryRelationCreateAPIDataRequest: FeeBasisCategoryRelationCreateAPIDataRequest,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<FeeBasisCategoryRelationAPIData>(
      {url: `/fund-family/${fundFamilyId}/fee-basis/${feeBasisId}/fee-basis-category/${feeBasisCategoryId}/relation`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: feeBasisCategoryRelationCreateAPIDataRequest
    },
      options);
    }
  


export const getFeeBasisCategoryRelationCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof feeBasisCategoryRelationCreate>>, TError,{fundFamilyId: string;feeBasisId: string;feeBasisCategoryId: string;data: FeeBasisCategoryRelationCreateAPIDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof feeBasisCategoryRelationCreate>>, TError,{fundFamilyId: string;feeBasisId: string;feeBasisCategoryId: string;data: FeeBasisCategoryRelationCreateAPIDataRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof feeBasisCategoryRelationCreate>>, {fundFamilyId: string;feeBasisId: string;feeBasisCategoryId: string;data: FeeBasisCategoryRelationCreateAPIDataRequest}> = (props) => {
          const {fundFamilyId,feeBasisId,feeBasisCategoryId,data} = props ?? {};

          return  feeBasisCategoryRelationCreate(fundFamilyId,feeBasisId,feeBasisCategoryId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type FeeBasisCategoryRelationCreateMutationResult = NonNullable<Awaited<ReturnType<typeof feeBasisCategoryRelationCreate>>>
    export type FeeBasisCategoryRelationCreateMutationBody = FeeBasisCategoryRelationCreateAPIDataRequest
    export type FeeBasisCategoryRelationCreateMutationError = unknown

    export const useFeeBasisCategoryRelationCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof feeBasisCategoryRelationCreate>>, TError,{fundFamilyId: string;feeBasisId: string;feeBasisCategoryId: string;data: FeeBasisCategoryRelationCreateAPIDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getFeeBasisCategoryRelationCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Gets fee basis represented as transaction calculation
 */
export const feeBasisAsTransactionCalculationRetrieve = (
    fundFamilyId: string,
    feeBasisId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<TransactionCalculationFeeBasisViewData>(
      {url: `/fund-family/${fundFamilyId}/fee-basis/${feeBasisId}/transaction-calculation`, method: 'GET', signal
    },
      options);
    }
  

export const getFeeBasisAsTransactionCalculationRetrieveQueryKey = (fundFamilyId: string,
    feeBasisId: string,) => {
    return [`/fund-family/${fundFamilyId}/fee-basis/${feeBasisId}/transaction-calculation`] as const;
    }

    
export const getFeeBasisAsTransactionCalculationRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof feeBasisAsTransactionCalculationRetrieve>>, TError = unknown>(fundFamilyId: string,
    feeBasisId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof feeBasisAsTransactionCalculationRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFeeBasisAsTransactionCalculationRetrieveQueryKey(fundFamilyId,feeBasisId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof feeBasisAsTransactionCalculationRetrieve>>> = ({ signal }) => feeBasisAsTransactionCalculationRetrieve(fundFamilyId,feeBasisId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && feeBasisId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof feeBasisAsTransactionCalculationRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type FeeBasisAsTransactionCalculationRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof feeBasisAsTransactionCalculationRetrieve>>>
export type FeeBasisAsTransactionCalculationRetrieveQueryError = unknown

export const useFeeBasisAsTransactionCalculationRetrieve = <TData = Awaited<ReturnType<typeof feeBasisAsTransactionCalculationRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    feeBasisId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof feeBasisAsTransactionCalculationRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFeeBasisAsTransactionCalculationRetrieveQueryOptions(fundFamilyId,feeBasisId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getFeeBasisAsTransactionCalculationRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof feeBasisAsTransactionCalculationRetrieve>>, TError = unknown>(fundFamilyId: string,
    feeBasisId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof feeBasisAsTransactionCalculationRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFeeBasisAsTransactionCalculationRetrieveQueryKey(fundFamilyId,feeBasisId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof feeBasisAsTransactionCalculationRetrieve>>> = ({ signal }) => feeBasisAsTransactionCalculationRetrieve(fundFamilyId,feeBasisId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && feeBasisId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof feeBasisAsTransactionCalculationRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type FeeBasisAsTransactionCalculationRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof feeBasisAsTransactionCalculationRetrieve>>>
export type FeeBasisAsTransactionCalculationRetrieveSuspenseQueryError = unknown

export const useFeeBasisAsTransactionCalculationRetrieveSuspense = <TData = Awaited<ReturnType<typeof feeBasisAsTransactionCalculationRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    feeBasisId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof feeBasisAsTransactionCalculationRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFeeBasisAsTransactionCalculationRetrieveSuspenseQueryOptions(fundFamilyId,feeBasisId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getFeeBasisAsTransactionCalculationRetrieveLoader = (paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,feeBasisId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,feeBasisId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (fundFamilyId && feeBasisId) {
            return appQueryClient.prefetchQuery({
              queryKey: getFeeBasisAsTransactionCalculationRetrieveQueryKey(fundFamilyId,feeBasisId),
              queryFn: () => feeBasisAsTransactionCalculationRetrieve(fundFamilyId,feeBasisId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Edits fee basis given a transaction calculation payload
 */
export const feeBasisAsTransactionCalculationUpdate = (
    fundFamilyId: string,
    feeBasisId: string,
    transactionCalculationPayloadCreateDataRequest: TransactionCalculationPayloadCreateDataRequest,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<TransactionCalculationFeeBasisViewData>(
      {url: `/fund-family/${fundFamilyId}/fee-basis/${feeBasisId}/transaction-calculation`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: transactionCalculationPayloadCreateDataRequest
    },
      options);
    }
  


export const getFeeBasisAsTransactionCalculationUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof feeBasisAsTransactionCalculationUpdate>>, TError,{fundFamilyId: string;feeBasisId: string;data: TransactionCalculationPayloadCreateDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof feeBasisAsTransactionCalculationUpdate>>, TError,{fundFamilyId: string;feeBasisId: string;data: TransactionCalculationPayloadCreateDataRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof feeBasisAsTransactionCalculationUpdate>>, {fundFamilyId: string;feeBasisId: string;data: TransactionCalculationPayloadCreateDataRequest}> = (props) => {
          const {fundFamilyId,feeBasisId,data} = props ?? {};

          return  feeBasisAsTransactionCalculationUpdate(fundFamilyId,feeBasisId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type FeeBasisAsTransactionCalculationUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof feeBasisAsTransactionCalculationUpdate>>>
    export type FeeBasisAsTransactionCalculationUpdateMutationBody = TransactionCalculationPayloadCreateDataRequest
    export type FeeBasisAsTransactionCalculationUpdateMutationError = unknown

    export const useFeeBasisAsTransactionCalculationUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof feeBasisAsTransactionCalculationUpdate>>, TError,{fundFamilyId: string;feeBasisId: string;data: TransactionCalculationPayloadCreateDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getFeeBasisAsTransactionCalculationUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Creates Fee Basis using Transaction Calculation Payload
 */
export const feeBasisAsTransactionCalculationCreate = (
    fundFamilyId: string,
    transactionCalculationPayloadCreateDataRequest: TransactionCalculationPayloadCreateDataRequest,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<TransactionCalculationFeeBasisViewData>(
      {url: `/fund-family/${fundFamilyId}/fee-basis/transaction-calculation`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: transactionCalculationPayloadCreateDataRequest
    },
      options);
    }
  


export const getFeeBasisAsTransactionCalculationCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof feeBasisAsTransactionCalculationCreate>>, TError,{fundFamilyId: string;data: TransactionCalculationPayloadCreateDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof feeBasisAsTransactionCalculationCreate>>, TError,{fundFamilyId: string;data: TransactionCalculationPayloadCreateDataRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof feeBasisAsTransactionCalculationCreate>>, {fundFamilyId: string;data: TransactionCalculationPayloadCreateDataRequest}> = (props) => {
          const {fundFamilyId,data} = props ?? {};

          return  feeBasisAsTransactionCalculationCreate(fundFamilyId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type FeeBasisAsTransactionCalculationCreateMutationResult = NonNullable<Awaited<ReturnType<typeof feeBasisAsTransactionCalculationCreate>>>
    export type FeeBasisAsTransactionCalculationCreateMutationBody = TransactionCalculationPayloadCreateDataRequest
    export type FeeBasisAsTransactionCalculationCreateMutationError = unknown

    export const useFeeBasisAsTransactionCalculationCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof feeBasisAsTransactionCalculationCreate>>, TError,{fundFamilyId: string;data: TransactionCalculationPayloadCreateDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getFeeBasisAsTransactionCalculationCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    